import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import { postGeofence } from '@app/actions/geofences/geofences'
import { saveConditionGeofenceName } from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectGeofencesName
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/GeofencesCondition/SelectGeofencesName/SelectGeofencesName'
import SelectGeofencesNameIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/GeofencesCondition/SelectGeofencesName/SelectGeofencesName'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectGeofencesNameIOS) : withStyles(SelectGeofencesName)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { isEditConditionMode } = state.scenes.currentSceneCreating
  const {
    address, lat, lng, size,
  } = state.geofences.geofenceInfo
  return {
    isMobile,
    path,
    isEditConditionMode,
    address,
    lat,
    lng,
    size,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  postGeofence,
  saveConditionGeofenceName,
}, dispatch)

enhance = withNotifications(enhance)
enhance = withAccessDenied(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectGeofencesNameEnhanced = enhance

export default withRouter(SelectGeofencesNameEnhanced)
